import WeekEvent from './WeekEvent';

export default WeekEvent;
